const QUERY_KEY = {
  TOKEN: ["token"],
  USER: ["user"],
  MEMES: ["memes"],
};

export default QUERY_KEY;
